import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar_old";
import Footer from "./Footer";
import axios from "axios";
import abni from "./images/abni.jpg";
import puja from "./images/puja.jpg";
import amar from "./images/amar.jpeg";
import vikash from "./images/vikash.jpg";


const Home = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [likedProfiles, setLikedProfiles] = useState(
    () => JSON.parse(localStorage.getItem("likedProfiles")) || []
  );
  const [filters, setFilters] = useState({
    lookingFor: "",
    ageFrom: "",
    ageTo: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [savedProfiles, setSavedProfiles] = useState(
    () => JSON.parse(localStorage.getItem("savedProfiles")) || []
  );
  const [darkMode, setDarkMode] = useState(false);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  // Sample profiles (can later fetch from backend)
  const [profiles, setProfiles] = useState([
    {
      id: 1,
      name: "Khushi Agrawal",
      age: 26,
      gender: "Bride",
      title: "Software Engineer",
      image: abni,
      address: "Indore",
      phone: "+919876543210",
      canChat: true,
      canCall: true,
    },
   
    {
      id: 2,
      name: "Amar Agrawal",
      age: 24,
      gender: "Male",
      title: "Website Developer",
      image: amar,
      address: "Noida",
      phone: "+919876543211",
      canChat: true,
      canCall: true,
    },
     {
      id: 3,
      name: "Priya Ojha",
      age: 24,
      gender: "Female",
      title: "Fashion Designer",
      image: puja,
      address: "Delhi",
      phone: "+919876543212",
      canChat: true,
      canCall: true,
    },
    {
      id: 4,
      name: "Riya",
      age: 23,
      gender: "Female",
      title: "Digital Marketer",
      image: "https://photosvibe.in/wp-content/uploads/cute-girl-pic11.jpg",
      address: "Ahmedabad",
      phone: "+919876543213",
      canChat: true,
      canCall: true,
    },
     {
      id: 5,
      name: "Vikash ojha",
      age: 26,
      gender: "Male",
      title: "Digital Marketer",
      image: vikash,
      address: "Ahmedabad",
      phone: "+919876543214",
      canChat: true,
      canCall: true,
    },
    {
      id: 6,
      name: "Sneha",
      age: 25,
      gender: "Female",
      title: "HR Executive",
      image: "https://photosvibe.in/wp-content/uploads/girl-dp13.jpg",
      address: "Kolkata",
      phone: "+919876543215",
      canChat: true,
      canCall: true,
    },
  ]);

  // ✅ Login check
  // useEffect(() => {
  //   const loggedUser = JSON.parse(localStorage.getItem("loggedInUser"));
  //   if (!loggedUser) {
  //     alert("Please login first!");
  //     navigate("/login");
  //   } else {
  //     setUser(loggedUser);
  //   }
  // }, [navigate]);

  // ✅ Apply search filters
  const handleSearch = () => setAppliedFilters(filters);

  // ✅ Handle call functionality
  const handleCall = (profile) => {
    // Disabled for now - showing upgrade message
    alert("Call feature is currently under maintenance. Please try again later.");
  };

  // ✅ Handle SMS functionality
  const handleSMS = (profile) => {
    // Disabled for now - showing upgrade message
    alert("Message feature is currently under maintenance. Please try again later.");
  };

  // ✅ New feature - View profile details
  const handleViewProfile = (profile) => {
    alert(`Profile Details:\n\nName: ${profile.name}\nAge: ${profile.age}\nProfession: ${profile.title}\nLocation: ${profile.address}\nPhone: ${profile.phone}\n\nFull profile view coming soon!`);
  };

  // ✅ New feature - Share profile
  const handleShareProfile = (profile) => {
    if (navigator.share) {
      navigator.share({
        title: `${profile.name} - ${profile.title}`,
        text: `Check out ${profile.name}'s profile on Agrawal Matrimony`,
        url: window.location.href
      });
    } else {
      // Fallback - copy to clipboard
      const profileText = `${profile.name} - ${profile.title}\nLocation: ${profile.address}\nView on Agrawal Matrimony`;
      navigator.clipboard.writeText(profileText);
      alert("Profile link copied to clipboard!");
    }
  };

  // ✅ New feature - Save/Bookmark profile
  const handleSaveProfile = (profile) => {
    const savedProfiles = JSON.parse(localStorage.getItem("savedProfiles")) || [];
    const isAlreadySaved = savedProfiles.some(p => p.id === profile.id);
    
    if (isAlreadySaved) {
      // Remove from saved
      const updatedSaved = savedProfiles.filter(p => p.id !== profile.id);
      localStorage.setItem("savedProfiles", JSON.stringify(updatedSaved));
      alert(`${profile.name} removed from saved profiles`);
    } else {
      // Add to saved
      const updatedSaved = [...savedProfiles, profile];
      localStorage.setItem("savedProfiles", JSON.stringify(updatedSaved));
      alert(`${profile.name} saved to your profiles!`);
    }
  };

  // ✅ Toggle like
  const toggleLike = (profile) => {
    const updatedLikes = likedProfiles.some((p) => p.id === profile.id)
      ? likedProfiles.filter((p) => p.id !== profile.id)
      : [...likedProfiles, profile];
    setLikedProfiles(updatedLikes);
    localStorage.setItem("likedProfiles", JSON.stringify(updatedLikes));
  };

  const isLiked = (profile) => likedProfiles.some((p) => p.id === profile.id);

  // ✅ Filter profiles
  const filteredProfiles = profiles.filter((profile) => {
    const { lookingFor, ageFrom, ageTo } = appliedFilters;
    const matchesGender = !lookingFor || profile.gender === lookingFor;
    const matchesAgeFrom = !ageFrom || profile.age >= parseInt(ageFrom);
    const matchesAgeTo = !ageTo || profile.age <= parseInt(ageTo);
    return matchesGender && matchesAgeFrom && matchesAgeTo;
  });

  
  return (
    <>
      {/* Navbar */}
          <div className="navbar-fixed">
  <Navbar />
</div>

      {/* Welcome Banner */}
      {user && (
        <div className="text-center bg-dark text-light py-2 shadow-sm mt-5">
          <h6 className="m-0">
            Welcome, <span className="text-warning">{user.name}</span> (
            {user.email})
          </h6>
        </div>
      )}

      {/* Search / Filter Section */}
      <section
        className="search_pro py-4"
        style={{ background: "linear-gradient(120deg, #1f1f1f, #121212)" }}
      >
        <div className="container mt-5">
          <div className="card p-4 shadow-lg mt-5" style={{ borderRadius: "15px", background: "#890528" }}>
            <h5 className="text-warning text-center mb-1">Agrawal</h5>
            <h6 className="text-light mb-3 text-center">Tradition. Trust. Love.</h6>

            <div className="row g-3">
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={filters.lookingFor}
                  onChange={(e) => setFilters({ ...filters, lookingFor: e.target.value })}
                >
                  <option value="">I am looking for a</option>
                  <option value="Groom">Groom</option>
                  <option value="Bride">Bride</option>
                </select>
              </div>
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={filters.ageFrom}
                  onChange={(e) => setFilters({ ...filters, ageFrom: e.target.value })}
                >
                  <option value="">Age From</option>
                  {Array.from({ length: 33 }, (_, i) => i + 18).map((age) => (
                    <option key={age} value={age}>{age}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={filters.ageTo}
                  onChange={(e) => setFilters({ ...filters, ageTo: e.target.value })}
                >
                  <option value="">Age To</option>
                  {Array.from({ length: 33 }, (_, i) => i + 18).map((age) => (
                    <option key={age} value={age}>{age}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 d-flex align-items-end">
                <button className="btn btn-warning w-100 fw-bold" onClick={handleSearch}>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Profiles */}
      <section className="profile-wrapper bg-dark py-5 mb-5">
        <div className="container">
          <h4 className="text-warning mb-4 text-center">New Profiles</h4>
          <div className="row g-4">
            {filteredProfiles.length ? (
              filteredProfiles.map((profile) => (
                <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={profile.id}>
                  <div className="card h-100 shadow-lg border-0" style={{ borderRadius: "15px", overflow: "hidden", transition: "transform 0.3s", background: "rgb(69 15 30 / 66%)" }}>
                    <img src={profile.image} className="card-img-top img-fluid" alt={profile.name} />
                    <div className="card-body d-flex flex-column justify-content-between text-white">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-1">{profile.name}, {profile.age}</h5>
                        <span className={`btn btn-sm ${isLiked(profile) ? "btn-danger" : "btn-outline-danger"}`} onClick={() => toggleLike(profile)}>❤️</span>
                      </div>
                      <p className="small mb-1 text-warning">{profile.title}</p>
                      <p className="card-text small text-light"><i className="bi bi-geo-alt me-1"></i>{profile.address}</p>

                      <div className="d-flex gap-2 mt-3">
                        {/* Call - Disabled */}
                        <button 
                          className="btn btn-outline-secondary btn-sm flex-fill"
                          disabled
                          onClick={() => handleCall(profile)}
                          title="Call feature under maintenance"
                        >
                          <i className="bi bi-telephone-fill me-1"></i> 
                          Call ⚠️
                        </button>
                        {/* Chat/SMS - Disabled */}
                        <button 
                          className="btn btn-outline-secondary btn-sm flex-fill"
                          disabled
                          onClick={() => handleSMS(profile)}
                          title="Message feature under maintenance"
                        >
                          <i className="bi bi-chat-dots-fill me-1"></i> 
                          SMS ⚠️
                        </button>
                        {/* More Details */}
                        <Link to="/profile" state={profile} className="btn btn-outline-warning btn-sm flex-fill text-center text-decoration-none">
                          <i className="bi bi-chevron-right"></i> More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-secondary">No profiles found for selected filters.</p>
            )}
          </div>
            <div className="mt-2 text-center">
              <Link to="/profile">
        <button className="btn btn-outline-warning">More Profile</button>
        </Link>
      </div>
        </div>
      </section>
    

      {/* Footer */}
      <Footer />

    </>
  );
};

export default Home;
